import { Button, Card, Col, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActionsLog from "../../../../components/common/ActionsLog";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Emails from "../../../../components/common/Emails";
import Notes from "../../../../components/common/Notes";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import Texts from "../../../../components/common/Texts";
import AccountingInformation from "../../components/AccountingInformation";
import FederalTax from "../../components/FederalTax";
import OnlinePayables from "../../components/OnlinePayables";
import PersonalInformation from "../../components/PersonalInformation";
import users from "../../../../assets/images/users.png";
import { tableData } from "../vendersData";
import VendorCommunications from "../../components/VendorCommunications";
import Compliance from "../../components/Compliance";
import Contact from "../../components/Contact";

import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../../firebase";

// import "./OwnerDetails.css";

function VendorDetails() {
  const [vendorDetails, setVendorDetails] = useState(null);
  const [renderData, setRenderData] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [user, loading] = useAuthState(auth);
  const [notes, setNotes] = useState([]);
  const { id } = useParams();

  const [isHideVendor, setIsHideVendor] = useState(false);
  const renderingData = (data) => {
    setRenderData(data);
    console.log(data);
  };
  const showHideVendorConfirm = () => {
    setIsHideVendor(true);
  };
  const handleOk = () => {
    setIsHideVendor(false);
  };
  const handleCancel = () => {
    setIsHideVendor(false);
  };
  useEffect(() => {
    const newObject = tableData.find((item) => {
      return item.id === Number(id);
    });
    setVendorDetails(newObject);
  }, []);

  const VendorDetailsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("New Vendor", "1", "", "", "/people/vendors/new"),
      RightBarMethod(
        "New Service Request",
        "2",
        "",
        "",
        "/maintenance/work-orders/service-requests/new"
      ),
      RightBarMethod(
        "Enter Bill",
        "3",
        "",
        "",
        "/accounting/payables_bills/bills/enter-bils"
      ),
      RightBarMethod("Purchase Orders", "4", "", "", ""),
      RightBarMethod(
        <span onClick={showHideVendorConfirm}>Hide Vendor</span>,
        "5",
        "",
        "",
        ""
      ),
      RightBarMethod("Download Text History", "6", "", "", ""),
    ]),
    RightBarMethod(
      "Reports",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Bill Detail", "7", "", "", "/"),
        RightBarMethod("Vendor Ledger", "8", "", "", "/"),
        RightBarMethod("Work Order", "9", "", "", "/"),
      ]
    ),
    RightBarMethod(
      "LETTERS",
      "t3",
      <i className="fa-solid fa-file-lines"></i>,
      [RightBarMethod("Print Envelope", "10", "", "", "/")]
    ),
    RightBarMethod(
      "HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("Set Up Vendor E-Checks", "11", "", "", "/"),
        RightBarMethod("Vendor Portal Overview", "12", "", "", "/"),
      ]
    ),
  ];
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setCompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  const getVendors = async () => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const vendorRef = collection(companyDocRef, "vendors");

      const docRef = doc(vendorRef, id);
      const docSnapshot = await getDoc(docRef);

      if (docSnapshot.exists()) {
        const userData = {
          ...docSnapshot.data(), // Spread the document's data
          id: docSnapshot.id, // Include the document's ID
        };
        setVendorDetails(userData);
      } else {
        console.log("Document not found!");
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while fetching user data");
    }
  };

  useEffect(() => {
    fetchCompanyName();
    if (companyName.length >= 2) {
      getVendors();
    }
    console.log(companyName.length);
  }, [renderData, companyName]);

  console.log("************************");
  console.log(vendorDetails);

  return (
    <>
      <Row gutter={[0, 24]} className="owner-details">
        <Col span={24}>
          <Row gutter={[24, 0]}>
            <Col span={4}>
              <Card>
                <div className="profile-container">
                  <img src={users} alt="" />
                  <p className="silver-text">
                    {vendorDetails?.vendorInfo.firstName}
                  </p>
                </div>
              </Card>
            </Col>
            <Col span={20}>
              <PersonalInformation
                data={vendorDetails?.vendorInfo}
                renderData={renderingData}
                peopleType="Vendor"
                companyName={companyName}
                collectionName="vendors"
                id={id}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Contact
            data={vendorDetails}
            renderData={renderingData}
            peopleType="Vendor"
            companyName={companyName}
            collectionName="vendors"
          />
        </Col>
        <Col span={24}>
          <VendorCommunications
          // data={vedndorDetails?.vendorCommunications}
          />
        </Col>
        <Col span={24}>
          <FederalTax
            data={vendorDetails?.federalTax}
            renderData={renderingData}
            company={companyName}
          />
        </Col>
        <Col span={24}>
          <AccountingInformation
            data={vendorDetails?.accountingInfo}
            peopleType="Vendor"
            renderData={renderingData}
            company={companyName}
          />
        </Col>
        <Col span={24}>
          <OnlinePayables
            data={vendorDetails?.onlinePaybles}
            peopleType="Vendor"
            renderData={renderingData}
            company={companyName}
          />
        </Col>
        <Col span={24}>
          <Compliance
            data={vendorDetails?.compliance}
            renderData={renderingData}
            company={companyName}
          />
        </Col>
        <Col span={24}>
          {companyName ? (
            <Notes
              notesForCollection="vendors"
              notesForCollectionId={id}
              companyName={companyName}
              notes={notes}
              setNotes={setNotes}
            />
          ) : null}
        </Col>
        {/* <Col span={24}>
          <Texts />
        </Col>
        <Col span={24}>
          <Emails />
        </Col>
        <Col span={24}>
          <ActionsLog />
        </Col> */}
        <Col span={24}>
          {companyName ? (
            <AttachmentsUpload
              id={id}
              data={vendorDetails?.attachments}
              companyName={companyName}
              collection="vendors"
            />
          ) : null}
        </Col>
      </Row>
      <div className="RightSidebar">
        <RightBar RightBarData={VendorDetailsRightBar} />
      </div>

      <Modal
        title="1 Warning"
        centered
        open={isHideVendor}
        footer={
          <div style={{ display: "flex", justifyContent: "start" }}>
            <Button type="primary" onClick={handleOk}>
              Hide
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </div>
        }
      >
        <p>Are you sure you want to hide this vendor?</p>
      </Modal>
    </>
  );
}

export default VendorDetails;
